<template>
  <section class="status-page">
    <div class="status-card animate-modal-enter">
      <div class="status-icon warning">
        <svg class="w-16 h-16 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
      </div>
      <h1 class="text-2xl md:text-3xl font-extrabold mt-6" style="color:#195493">Telefone já cadastrado</h1>
      <p class="text-gray-600 mt-3 text-lg">Este telefone já possui uma inscrição no 5º Pedal no Paraíso 2026.</p>
      <p class="text-sm text-gray-400 mt-2">Verifique seu e-mail ou WhatsApp para encontrar o número de inscrição.</p>
      <router-link to="/" class="btn-back">Voltar ao Início</router-link>
    </div>
  </section>
</template>

<script>
export default { name: "PageExistente2" };
</script>

<style scoped>
.status-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #195493 0%, #0f3460 100%);
  padding: 2rem;
}
.status-card {
  background: white;
  border-radius: 1.5rem;
  padding: 3rem;
  text-align: center;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 25px 60px rgba(0,0,0,0.3);
}
.status-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
.status-icon.warning { background: #f39c12; }
.btn-back {
  display: inline-block;
  background: #E8652D;
  color: white;
  font-weight: 700;
  padding: 0.8rem 2rem;
  border-radius: 50px;
  text-decoration: none;
  transition: background 0.3s;
  text-transform: uppercase;
  font-size: 0.9rem;
  letter-spacing: 1px;
  margin-top: 1.5rem;
}
.btn-back:hover { background: #c9521f; }
</style>
